import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableFilterAutocompleteComponent } from './table-filter-autocomplete.component';
import { MaterialModule } from '../../material-components.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  declarations: [TableFilterAutocompleteComponent],
  exports: [TableFilterAutocompleteComponent],
})

export class TableFilterAutocompleteModule {
}
